import React, { useState } from 'react';
import Footer from '../../component/Footer';
import Navbar from '../../component/Navbar';
import { Link } from 'react-router-dom';
import SideBar from './SideBar';
import Arrow from '../Arrow';
import Generalsidebar from '../Generalsidebar';

function ChangePassword() {
  const [showSidebar, setShowSidebar] = useState(false);

  const userInfo = JSON.parse(localStorage.getItem('userLoggedIn'))
    ? JSON.parse(localStorage.getItem('userLoggedIn'))
    : { firstName: '' };

  console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  return (
    <div>
      <Navbar />
      <div onClick={handleArrowClick} className='absolute top-24 left-12 z-20'>
        <Arrow />
      </div>
      <div className={showSidebar ? 'show-sidebar' : 'hidden'}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <section className='flex bg-[#D9D9D9]'>
        {/* --------------sidebar----------------
        <div className="hidden md:block h-full py-20 px-4">
          <Link to="/profile">
            {" "}
            <button className="text-[#295700] border border-[#295700] px-4 py-1 rounded-sm block w-[120px] text-center mb-8">
              General
            </button>
          </Link>
          <Link to="/settingsprofile">
            {" "}
            <button className="bg-[#295700] text-white px-4 py-1 rounded-sm block w-[120px] text-center mb-6">
              Settings
            </button>
          </Link>
          <Link to="/signIn">
            <button className="text-[#295700] border border-[#295700] px-4 py-1 rounded-sm block w-[120px] text-center mb-8">
              Log Out
            </button>
          </Link>
        </div> */}
        <SideBar />
        {/* --------------Main Area---------------- */}
        <div className='px-12 md:pl-32 min-h-[80vh] w-fit'>
          {/* -----------Input Section----------- */}
          <div className='flex flex-col py-12 gap-12'>
            <div className='flex flex-col gap-3'>
              <h3>
                <strong>Current Password</strong>
              </h3>
              <input
                type='password'
                id='password'
                placeholder='Current Password'
                className='block w-96 rounded-sm shadow-md px-2 py-1'
              />
            </div>
            <div className='flex flex-col gap-3'>
              <h3>
                <strong>New Password</strong>
              </h3>
              <input
                type='password'
                id='password'
                placeholder='New Password '
                className='block w-96 rounded-sm shadow-md px-2 py-1'
              />
            </div>
            <div className='flex flex-col gap-3'>
              <h3>
                <strong>Confirm Password</strong>
              </h3>
              <input
                type='password'
                id='password'
                placeholder='Confirm Password'
                className='block w-96 rounded-sm shadow-md px-2 py-1'
              />
            </div>
          </div>
          <div className='mt-8 flex md:block justify-center'>
            <Link to='/profile'>
              <button className='block w-32 mx-auto font-semibold text-center text-white bg-[#295700] py-1 rounded-md'>
                SAVE
              </button>
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default ChangePassword;
